import { hashCode } from "../../components/Common";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";

export const GetColourUpdateString = (threeDMode, job = null) => {
    let out_string = "";
    let skylights = GetSpecAllAreas(BASIC_SPECS_SECTIONS.SKYLIGHTS, null, 0);
    out_string += JSON.stringify(skylights);
    let roofsheet_colour_in_areas = GetSpecAllAreas(
        BASIC_SPECS_SECTIONS.ROOF_SHEETING,
        "RoofSheetColour",
        "Classic Cream/Grey"
    );
    for (var val of roofsheet_colour_in_areas) out_string += val;
    let skylight_colour_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "SkylightColour", "Clear");
    for (var val of skylight_colour_in_areas) out_string += val;
    let ReverseRoll_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "ReverseRoll", "false");
    for (var val of ReverseRoll_in_areas) out_string += val;
    let RidgeColour_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "RidgeColour", "false");
    for (var val of RidgeColour_in_areas) out_string += val;
    let FlashingColour_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "FlashingColour", "false");
    for (var val of FlashingColour_in_areas) out_string += val;

    let BeamCol_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamCol1", "Classic Cream");
    for (var val of BeamCol_in_areas) out_string += val;
    let BeamCol2_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamCol2", "Classic Cream");
    for (var val of BeamCol2_in_areas) out_string += val;
    let BeamCol3_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamCol3", "Classic Cream");
    for (var val of BeamCol3_in_areas) out_string += val;
    let BeamCol4_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "BeamCol4", "Classic Cream");
    for (var val of BeamCol4_in_areas) out_string += val;
    let PostCol_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "PostCol", "Classic Cream");
    for (var val of PostCol_in_areas) out_string += val;

    let gutter_colour_in_areas = GetSpecAllAreas(
        BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
        "GutterCol",
        "Classic Cream"
    );
    for (var val of gutter_colour_in_areas) out_string += val;

    let gutter_type_in_areas = GetSpecAllAreas(
        BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
        "GutterType",
        "Classic Cream"
    );
    out_string += JSON.stringify(gutter_type_in_areas);

    let downpipe_colour_in_areas = GetSpecAllAreas(
        BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
        "DownpipeCol",
        "Classic Cream"
    );
    out_string += JSON.stringify(downpipe_colour_in_areas);
    // out_string += JSON.stringify(GetSpecAllAreas("OPTIONS", "SlatColour", ""));

    out_string += window?.app?.designer?.designer3D["ATTACHMENT_MESH_MODE"];
    out_string += window?.app?.designer?.designer3D["ROOFSHEET__MESH_MODE"];
    out_string += window?.app?.designer?.designer3D["BEAM_AND_POST_MESH_MODE"];
    out_string += window?.app?.designer?.designer3D["GUTTERS_AND_FLASHING_MESH_MODE"];
    out_string += window?.app?.designer?.designer3D["FOOTINGS_MESH_MODE"];

    out_string += window?.app?.designer?.designer2D["SHOW_BEAM_LENGTHS"];
    out_string += window?.app?.designer?.designer2D["SHOW_POST_DIMENSIONS"];

    if (!threeDMode) {
        // out_string += JSON.stringify(job?job.QuoteParameters.ENGINEERING:window.job.QuoteParameters.ENGINEERING);
    }

    if (threeDMode) {
        let wall_type = window.job?.SiteParameters?.ExistingStructure?.WallType;
        let house_roof_col = window.job?.SiteParameters?.ExistingStructure?.RoofColour;
        let house_roof_type = window.job?.SiteParameters?.ExistingStructure?.RoofType;
        let FloorType = window.job?.SiteParameters?.ExistingStructure?.FloorType;

        out_string += wall_type + house_roof_col + house_roof_type + FloorType;

        //3d Display modes

        const VERANDAH_MESH_MODE = window?.app?.designer?.designer3D["VERANDAH_MESH_MODE"];
        const VERANDAH_EDGE_LINE_MODE = window?.app?.designer?.designer3D["VERANDAH_EDGE_LINE_MODE"];

        out_string += VERANDAH_MESH_MODE + VERANDAH_EDGE_LINE_MODE;

        let infill_front = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfill1", "Plain");
        let infill_colour_front = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfillColour1", "Plain");
        let infill_display_colour_front = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
            "TrussInfillDisplayColour1",
            "Plain"
        );
        out_string +=
            JSON.stringify(infill_colour_front) +
            JSON.stringify(infill_front) +
            JSON.stringify(infill_display_colour_front);
        let infill_back = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfill2", "Plain");
        let infill_colour_back = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfillColour2", "Plain");
        let infill_display_colour_back = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
            "TrussInfillDisplayColour2",
            "Plain"
        );
        out_string +=
            JSON.stringify(infill_colour_back) +
            JSON.stringify(infill_back) +
            JSON.stringify(infill_display_colour_back);
    }
    return hashCode(out_string);
};

export const GetBOMUpdateString = () => {
    let out_string = "";
    let shape = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, null, 0);
    out_string += JSON.stringify(shape);
    return hashCode(out_string);
};

export function GetSpecAllAreas(Section, Parameter, default_value = "") {
    let subsection = null;
    if (Parameter && Parameter.includes(".")) {
        let parameter_split = Parameter.split(".");
        subsection = parameter_split[0];
        Parameter = parameter_split[1];
    } else if (Section && Section.includes(".")) {
        let section_split = Section.split(".");
        Section = section_split[0];
        subsection = section_split[1];
    }

    var values = [];
    if (!window.job) return values;
    if (window?.job?.AreaSpecifications) {
        for (var area of window.job.AreaSpecifications) {
            if (area[Section] && (Parameter === null || Parameter === undefined)) {
                if (subsection) values.push(area[Section][subsection]);
                else values.push(area[Section]);
            } else if (area[Section] && area[Section][Parameter]) {
                values.push(area[Section][Parameter]);
            } else {
                values.push(default_value);
            }
        }
    }
    return values;
}

export const GetShapeUpdateString = (threeDMode = false, engineering = false) => {
    let out_string = "";
    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.SHAPE, null, 0));
    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.ATTACHMENTS, null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("BEAMSPECMODIFICATIONS", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("BEAMMODIFICATIONS", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("BeamWallExtends", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("POSTMODIFICATIONS", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("BEAMADJUSTMENTS", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("POSTADJUSTMENTS", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("PORTALPOSTS", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("LabelAdjustments", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("DECK_PARAMETERS", null, 0));

    out_string += JSON.stringify(GetSpecAllAreas("DrawingNotes", null, 0));
    if (!engineering) out_string += JSON.stringify(GetSpecAllAreas("SlatPanels", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas("NewBeams", null, 0));

    out_string += JSON.stringify(GetSpecAllAreas("Footings", null, 0));
    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "DownlightData")); // console.log("cutouts",cutouts);
    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "RoofGroupType")); // console.log("cutouts",cutouts);
    let roofSubType = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "RoofSubType");
    out_string += JSON.stringify(roofSubType); // console.log("cutouts",cutouts);
    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "RoofSpan"));

    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "SheetLaying"));
    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "SheetLayingOffset"));

    if (window?.job?.AreaSpecifications) {
        for (var area of window.job.AreaSpecifications) {
            let roofsheet_data = area[BASIC_SPECS_SECTIONS.ROOF_SHEETING]["RoofSheetData"];
            if (
                area?.SKYLIGHTS &&
                roofsheet_data.skylight_coverage &&
                roofsheet_data.skylight_coverage != roofsheet_data.coverage
            ) {
                out_string += JSON.stringify(area?.SKYLIGHTS);
            }
        }
    }

    if (!engineering) {
        let GutterF_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterF", "");
        out_string += JSON.stringify(GutterF_in_areas);
        let GutterL_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterL", "");
        out_string += JSON.stringify(GutterL_in_areas);
        let GutterR_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterR", "");
        out_string += JSON.stringify(GutterR_in_areas);
        let GutterB_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterB", "");
        out_string += JSON.stringify(GutterB_in_areas);
        let GutterType_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "GutterType", "");
        out_string += JSON.stringify(GutterType_in_areas);

        out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "BoxGutterWidth", ""));

        out_string += JSON.stringify(
            GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "AttachmentGutterF", "")
        );
        out_string += JSON.stringify(
            GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "AttachmentGutterL", "")
        );
        out_string += JSON.stringify(
            GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "AttachmentGutterR", "")
        );
        out_string += JSON.stringify(
            GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "AttachmentGutterB", "")
        );

        let AddAutomaticDownpipes = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "AddAutomaticDownpipes"
        );
        out_string += JSON.stringify(AddAutomaticDownpipes);
        let downpipes = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "Downpipes", 0);
        out_string += JSON.stringify(downpipes);
    }

    let beamandpostdata = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, null, 0);
    for (var area_beam_data of beamandpostdata) {
        let area = [
            area_beam_data.BeamType1,
            area_beam_data.BeamType2,
            area_beam_data.BeamType3,
            area_beam_data.BeamType4,
            area_beam_data.PostType,
            area_beam_data.BeamSpacing,
            area_beam_data.PostSpacing,
            area_beam_data.OmitLeftBeam,
            area_beam_data.OmitRightBeam,
            area_beam_data.MatchSideBeams,
            area_beam_data.NumMiddlePosts,
            area_beam_data.PurlinSpacing,
            area_beam_data.NumPurlins,
            area_beam_data.NumPortals,
            area_beam_data.NumExtraPortals,
            area_beam_data.NumInternalRafters,
            area_beam_data.RemoveInternalRaftersWithNoPurlins,
            area_beam_data.NumExtraPurlins,
            area_beam_data.HasRidgeBeam,
            area_beam_data.SlimlineGable,
            area_beam_data.PostExternalConnectors,
            area_beam_data.FootingType,
            area_beam_data.NumExtraPostsFront1,
            area_beam_data.NumExtraPostsBack1,
            area_beam_data.NumExtraPostsCFLX,
            area_beam_data.NumExtraPostsCFRX,
            area_beam_data.NumExtraPostsCBLX,
            area_beam_data.NumExtraPostsCBRX,
            area_beam_data.CornerPostsFullHeight,
            area_beam_data.IntermediatePostsFullHeight,
            area_beam_data.CornerPostsFullHeightOffset,
            area_beam_data.CollarTie,
            area_beam_data.CollarTieBeam,
            area_beam_data.PortalPostType,
            area_beam_data.DoubleIntermediateRafters,
            area_beam_data.CollarTieEnd1,
            area_beam_data.CollarTieEnd2,
            area_beam_data.GableTopPurlinOffset,
            area_beam_data.AutoAddBeamBreakPost,
            area_beam_data.JackRafters,
            area_beam_data.BearerLocations,
            area_beam_data.FootingShape,
        ];

        out_string += JSON.stringify(area); // console.log("cutouts",cutouts);
    }

    out_string += window.job?.DesignParameters?.UseAreaJoinExtensions;
    out_string += window.job?.SiteParameters?.RiserBracketSpacing;
    out_string += window.job?.SiteParameters?.RafterBracketSpacing;
    out_string += JSON.stringify(window.job?.SiteParameters?.ExistingStructure);
    out_string += window.job?.SiteParameters?.WindData?.WindZone;
    out_string += window.job?.SiteParameters?.WindData?.Blocking;
    out_string += window.job?.SiteParameters?.WindData?.importance_level;

    let downligh_flashing = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "DownlightFlashing", "1");
    out_string += JSON.stringify(downligh_flashing);

    let InfillBeamType = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "InfillBeamType", "1");
    out_string += JSON.stringify(InfillBeamType);
    let HasInfillBeam1 = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "HasInfillBeam1", "1");
    out_string += JSON.stringify(HasInfillBeam1);
    let HasInfillBeam2 = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "HasInfillBeam2", "1");
    out_string += JSON.stringify(HasInfillBeam2);
    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "InfillEndAlign1", "1"));
    out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "InfillEndAlign2", "1"));

    if (threeDMode && !engineering) {
        out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "HasInfillStrut1", "1"));
        out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "HasInfillStrut2", "1"));

        let InfillInset1 = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "InfillInset1", "1");
        out_string += JSON.stringify(InfillInset1);
        let InfillInset2 = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "InfillInset2", "1");
        out_string += JSON.stringify(InfillInset2);

        out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfill1", ""));
        out_string += JSON.stringify(GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfill2", ""));

        let DownpipeType_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES, "DownpipeType", "");
        out_string += JSON.stringify(DownpipeType_in_areas);

        let DECORATIONS = GetSpecAllAreas("DECORATIONS", null, 0);
        out_string += JSON.stringify(DECORATIONS);
        let existingStructure = window.job?.SiteParameters?.ExistingStructure;
        let existing_check = [];
        if (existingStructure) {
            existing_check = [
                existingStructure.RoofPitch,
                existingStructure.FasciaHeight,
                existingStructure.WallHeight,
                existingStructure.EaveDepth,
                existingStructure.GutterWidth,
                existingStructure.RoofType,
            ];
        }
        out_string += JSON.stringify(existing_check);
        // out_string += JSON.stringify(GetSpecAllAreas("OPTIONS", "SlatType", ""));
        // out_string += JSON.stringify(GetSpecAllAreas("OPTIONS", "SlatRetainerSpacing", ""));
    }

    return hashCode(out_string);
};
